import React, { useMemo } from 'react'
import { Button, Flex, Modal, RadioChangeEvent } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import '../../../../styles/antd/formStyles.css'
import { usePatientContext } from '../../PatientsView'
import { usePatientTabContext } from '../../PatientTabs'
import { recordedDataRadioSizing } from '../RecordedEcgTab/RecordedEcgTabStyle'
import {
  createChartData,
  createTimeArray,
  generateTimeTicks,
  getMillisecondsFromHour,
} from './util'
import {
  getAddsData,
  selectAddsDataByKey,
} from '../../../../state/addsData/addsDataReducer'
import { AddsChartTabPropsType } from './types'
import { selectHospitalName } from '../../../../state/auth/authReducer'
import AddsChart from './AddsChart'
import { ExpandOutlined } from '@ant-design/icons'
import adds_chart_image from '../../../../assets/adds_chart_image.png'
import AddsForm from './AddsForm'

function AddsChartTab({
  patientKey,
  patientName,
  patientDOB,
  patientAge,
  doctorName,
}: AddsChartTabPropsType) {
  const dispatch = useDispatch()
  const hospitalName = useSelector(selectHospitalName)
  const [durationHours, setDurationHours] = useState<number>(24)
  const [intervalMinutes, setIntervalMinutes] = useState<number>(10)
  const endTime = new Date().valueOf()
  const startTime = endTime - getMillisecondsFromHour(durationHours)
  const [isPrintMode, setIsPrintMode] = useState<boolean>(false)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [syncCount, setSyncCount] = useState<number>(0)

  const sync = () => {
    setSyncCount((prev) => prev + 1)
  }

  useEffect(() => {
    dispatch(getAddsData({ patientKey, startTime, endTime }))
  }, [durationHours, syncCount])

  const timeArray = useMemo(
    () => createTimeArray(startTime, endTime, intervalMinutes),
    [durationHours, intervalMinutes, syncCount]
  )

  const timeTicks = generateTimeTicks(timeArray, durationHours, intervalMinutes)

  const addsData = useSelector(selectAddsDataByKey(patientKey))?.addsData
  const chartData = addsData
    ? createChartData(timeArray, intervalMinutes, addsData)
    : []

  const onIntervalChange = (event: RadioChangeEvent) => {
    setIntervalMinutes(event.target.value)
  }

  const onDurationChange = (event: RadioChangeEvent) => {
    setDurationHours(event.target.value)
  }

  const printToggle = () => {
    setIsPrintMode((prevMode) => !prevMode)
  }

  const showModal = () => {
    sync()
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  return (
    <Flex justify='space-between' align='center' style={{ width: '100%' }}>
      <Flex justify='center' align='center' flex={1} vertical>
        <Button
          onClick={showModal}
          style={{
            height: '300px',
            width: '250px',
            overflow: 'hidden',
          }}
        >
          <img
            src={adds_chart_image}
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
              filter: 'blur(3px)',
            }}
          />
          <ExpandOutlined style={{ position: 'relative', right: '111px' }} />
        </Button>
      </Flex>
      <Flex flex={3.5}>
        <AddsForm patientKey={patientKey} />
      </Flex>
      <Modal
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        width='100%'
        style={{ top: 6 }}
      >
        <AddsChart
          patientDetails={{
            patientKey: patientKey,
            patientName: patientName,
            patientDOB: patientDOB,
            patientAge: patientAge,
            doctorName: doctorName,
            hospitalName: hospitalName,
          }}
          chartData={chartData}
          timeTicks={timeTicks}
          startTime={startTime}
          endTime={endTime}
          timeArray={timeArray}
          isPrintMode={isPrintMode}
          sync={sync}
          onDurationChange={onDurationChange}
          onIntervalChange={onIntervalChange}
          printToggle={printToggle}
        />
      </Modal>
    </Flex>
  )
}
export default React.memo(AddsChartTab)
